riot.tag2('bbc-notifications-drawer', '<bbc-notifications-error-banner if="{opts.error.inner && !opts.error.main}" type="{opts.error.inner}"></bbc-notifications-error-banner> <bbc-notifications-error-view if="{opts.error.main}" type="{opts.error.main}"></bbc-notifications-error-view> <div if="{!opts.error.main && opts.state}"> <bbc-notifications-signed-in-view if="{opts.state.signedIn === true}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" state="{opts.state}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}" load-onboarding="{this.loadOnboarding}" view="{opts.view}"></bbc-notifications-signed-in-view> <bbc-notifications-signed-out-view if="{opts.state.signedIn === false}" state="{opts.state}"></bbc-notifications-signed-out-view> </div>', '', '', function(opts) {
'use strict';

var _this = this;

this.basePath = opts.mainApp.basePath;

this.on('mount', function () {
    // Create drawer holder
    var drawerName = 'notifications';
    var drawerContent = document.createElement('div');
    drawerContent.className = 'orb-panel';
    drawerContent.appendChild(_this.root);

    // Move drawer into Orbit
    opts.orb.addDrawer(drawerName, document.querySelector('.js-notification-link'), drawerContent, opts.componentApp.drawerStateChangedCallback);
});

this.on('updated', function () {
    if (_this.updateFocus) {
        console.log('Updating focus', _this.updateFocus);

        var el = document.querySelector(_this.updateFocus);
        if (el) {
            el.focus();
        }

        _this.updateFocus = null;
    }

    opts.mainApp.updateDrawerHeight();
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-drawer.tag
 ** module id = 18
 ** module chunks = 0
 **/